export const SET_SESSION_DATA = "@USER/SET_SESSION_DATA";
export const REMOVE_SESSION_DATA = "@USER/REMOVE_SESSION_DATA";
export const USER_LOGGED_OUT = "@USER/USER_LOGGED_OUT";
export const REQUEST_LOGOUT = "@USER/REQUEST_LOGOUT";
export const UPDATE = "@USER/UPDATE";
export const UPDATE_SUCCESS = "@USER/UPDATE_SUCCESS";
export const UPDATE_FAIL = "@USER/UPDATE_FAIL";
